/**
 * Manages a waiting list for items with id and value
 */
export default function WaitingList() {
  const waitingList = [];

  /**
   * Add an item to the list
   */
  const add = (id, value) => {
    waitingList.push({ id, value });
  };

  /**
   * Get an item from the list
   */
  const get = id => {
    const item = waitingList.find(item => item.id === id);
    return item ? item.value : null;
  };

  /**
   * Get all the items in the list
   */
  const getAll = () => {
    return waitingList.map(item => item.value);
  };

  /**
   * Like get, but removes the item as well
   */
  const pluck = id => {
    const index = waitingList.findIndex(item => item.id === id);
    const item = waitingList[index];
    waitingList.splice(index, 1);
    return item ? item.value : null;
  };

  /**
   * Remove an item from the list
   */
  const remove = id => {
    const index = waitingList.findIndex(item => item.id === id);
    waitingList.splice(index, 1);
  };

  return Object.freeze({ add, get, getAll, pluck, remove });
}
